// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__kvVHN","navigation":"layout_navigation__gyZ6W","content":"layout_content__W31Lv"};